export default __webpack_public_path__ + "static/media/commandLog.517ba492.svg";